import React, { memo } from 'react';

import { Checkbox as AntCheckbox } from 'antd';

import type { Action, GroupModule } from 'v2/interfaces/access-control';

type Props = {
  action: Action;
  module: GroupModule;
  handleActionsChange: (action: Action, checked: boolean) => void;
  isChecked: boolean;
  isDisabled: boolean;
};

function Checkbox({ action, handleActionsChange, isChecked, isDisabled }: Props) {
  return (
    <AntCheckbox
      id={`${action.fullname}-${action.module_id}`}
      checked={isChecked}
      onChange={e => handleActionsChange(action, e.target.checked)}
      disabled={isDisabled}
    >
      {action.name
        .replace(/Blinket/gi, 'Eduzz Eventos')
        .replace(/Checkout Sun/gi, 'Eduzz Checkout')
        .replace(/Checkout Elements/gi, 'Eduzz Checkout Elements')}
    </AntCheckbox>
  );
}

export default memo(Checkbox);
